export const remove = <T>(arr: T[], value: T) => arr.filter((item) => item !== value);
